import { render, staticRenderFns } from "./Appliances.vue?vue&type=template&id=8a0a273a&scoped=true"
import script from "./Appliances.vue?vue&type=script&lang=js"
export * from "./Appliances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a0a273a",
  null
  
)

export default component.exports